import GATSBY_COMPILED_MDX from "/codebuild/output/src1016370688/src/actions-runner/_work/devopstar.com/devopstar.com/content/blog/exploring-interpretable-and-controllable-face-reenactment-icface/index.mdx";
import React from 'react';
import {graphql} from 'gatsby';
import {GatsbyImage} from 'gatsby-plugin-image';
import Seo from '@components/seo';
import Layout from '@components/Layout/Layout';
import BlogLayout from '@components/Blog/BlogLayout';
import GithubCard from '@components/Blog/GithubCard';
import SocialShareSection from '@components/common/SocialShareSection';
import {BlogDateAndReadTime} from '@components/Blog/BlogCard';
import {DiscussionEmbed} from 'disqus-react';
import {siteUrl, disqusShortName} from '../../config/website';
const BlogPost = ({data, pageContext, children}) => {
  const {title, date, featuredImage, githubRepo, ogImage, published} = data.mdx.frontmatter;
  const {excerpt, id} = data.mdx;
  const {timeToRead} = data.mdx.fields;
  const baseSlugUrl = siteUrl + pageContext.slug;
  const disqusConfig = {
    identifier: id,
    title: title,
    url: baseSlugUrl
  };
  return React.createElement(Layout, null, React.createElement(Seo, {
    isBlogPost: true,
    title: title,
    description: excerpt,
    slug: pageContext.slug,
    ogImage: ogImage
  }), React.createElement(BlogLayout, {
    sharerSection: React.createElement("div", null, React.createElement("h4", null, "Share on"), React.createElement(SocialShareSection, {
      baseSlugUrl: baseSlugUrl,
      title: title
    }), React.createElement("hr", {
      style: {
        margin: '25px 0'
      }
    }))
  }, React.createElement(BlogDateAndReadTime, {
    date: date,
    readtime: timeToRead.text
  }), React.createElement("h1", null, title), published ? React.createElement(GatsbyImage, {
    image: featuredImage.childImageSharp.gatsbyImageData,
    alt: title
  }) : React.createElement("p"), React.createElement("hr"), githubRepo ? React.createElement("div", null, React.createElement(GithubCard, {
    githubRepo: githubRepo
  }), React.createElement("hr")) : React.createElement("p"), React.createElement("span", {
    className: "markdown-content"
  }, children), React.createElement(DiscussionEmbed, {
    shortname: disqusShortName,
    config: disqusConfig
  })));
};
export const query = graphql`query ($slug: String!) {
  mdx(fields: {slug: {eq: $slug}}) {
    excerpt
    id
    fields {
      timeToRead {
        text
      }
    }
    frontmatter {
      featuredImage {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      githubRepo
      ogImage {
        publicURL
      }
      published
      date(formatString: "MMMM DD, YYYY", locale: "en")
      title
    }
  }
}
`;
BlogPost
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
